import { create, filter, findAll, findOne, update } from "@/store/Crud/functions/actions";
import { resetSave } from "@/store/Crud/functions/actions";
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    resetSave,
};
